import * as Mui from "@material-ui/core";
import Fixed from "./fixed";

const FixedWhiteBackground = Mui.styled(Fixed)(({ theme }) => ({
  paddingTop: theme.spacing(0),
  backgroundColor: theme.palette.common.white
}));

export default FixedWhiteBackground;
